import { render, staticRenderFns } from "./YChip.vue?vue&type=template&id=c265e3de&scoped=true&lang=pug&"
import script from "./YChip.vue?vue&type=script&lang=js&"
export * from "./YChip.vue?vue&type=script&lang=js&"
import style0 from "./YChip.vue?vue&type=style&index=0&id=c265e3de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c265e3de",
  null
  
)

export default component.exports